export default [
	{
		dataIndex: 'reconcile_time',
		key: 'reconcile_time',
		title: 'Reconcile Time',
		width: 150,
		scopedSlots: {customRender: 'reconcileTime'}
	},
	{
		dataIndex: 'transaction_time',
		key: 'transaction_time',
		title: 'Transaction Time',
		width: 150,
		scopedSlots: {customRender: 'transactionTime'}
	},
	{
		key: 'transaction',
		title: 'Transaction',
		scopedSlots: {customRender: 'transaction'}
	},
	{
		key: 'subscriber',
		title: 'Subscriber',
		scopedSlots: {customRender: 'subscriber'}
	}, {
		key: 'client',
		title: 'Client',
		scopedSlots: {customRender: 'client'}
	}, {
		key: 'biller',
		title: 'Biller',
		scopedSlots: {customRender: 'biller'}
	}, {
		key: 'profit',
		title: 'Profit',
		scopedSlots: {customRender: 'profit'}
	}
]
